import { gql } from 'apollo-boost';

export const GET_ABOUT = gql`
    query {
        about {
            updatedAt
            media {
                type
                filename
                url
            }
        }
    } 
`;


export const GET_INTROS = gql`
    query getIntros($offsetDate: String, $limit: Int!) {
        intros(offsetDate: $offsetDate, limit: $limit) {
            count
            posts {
                uid
                date
                title
                description
                linkText
                linkURL
                cover {
                    type
                    filename
                    url
                }
            }
        }
    }
`;


export const GET_INTRO = gql`
    query getIntro($uid: String!) {
        intro(uid: $uid) {
            post {
                uid
                type
                date
                title
                description
                linkText
                linkURL
                year
                media {
                    type
                    url
                }
            }
            nextUid
        }
    }
`;
